<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox" fill="none">
    <path d="M1.54076 12.8417C1.11702 12.8417 0.754288 12.6907 0.452573 12.3889C0.150858 12.0868 0 11.7239 0 11.2999V1.53405C0 1.10999 0.150858 0.748298 0.452573 0.448979C0.754288 0.149659 1.11702 0 1.54076 0H11.2254C11.4653 0 11.6926 0.052549 11.9073 0.157646C12.122 0.262743 12.3087 0.414159 12.4674 0.611895L16.8667 6.42083L12.4674 12.2298C12.3087 12.4275 12.122 12.5789 11.9073 12.684C11.6926 12.7891 11.4653 12.8417 11.2254 12.8417H1.54076ZM1.54076 11.5958H11.2254C11.2746 11.5958 11.3192 11.5866 11.3591 11.5683C11.3991 11.5498 11.4344 11.522 11.465 11.4851L15.3094 6.42083L11.465 1.35652C11.4344 1.31962 11.3991 1.29191 11.3591 1.27339C11.3192 1.25502 11.2746 1.24583 11.2254 1.24583H1.54076C1.45467 1.24583 1.38399 1.27347 1.32873 1.32873C1.27347 1.38399 1.24583 1.45467 1.24583 1.54076V11.3009C1.24583 11.387 1.27347 11.4577 1.32873 11.5129C1.38399 11.5682 1.45467 11.5958 1.54076 11.5958Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'AddTag',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 17,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 13,
    },
    color: {
      type: String,
      required: false,
      default: '#62646A',
    },
  },
  computed: {
    viewBox() {
      return `0 0 ${this.width} ${this.height}`
    }
  }
};
</script>
